import React from 'react';
import { Clock, Loader2, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { ProActivationStatus } from '../../hooks/useProActivation';
interface ProActivationPendingProps {
  status: ProActivationStatus;
  onRetry: () => void;
}

/** Shown after a Pro purchase until the profile row reports is_pro === true. */
export function ProActivationPending({
  status,
  onRetry
}: ProActivationPendingProps) {
  const navigate = useNavigate();
  const timedOut = status === 'timed_out';
  return <div className="flex min-h-screen w-full items-center justify-center bg-forensic-bg px-5 text-white" data-id="element-1647" data-mp="pp0h807opgbq">
      <div role="status" aria-live="polite" className="w-full max-w-md rounded-2xl border border-forensic-line bg-forensic-surface p-8 text-center" data-id="element-1648" data-mp="tsge8xno1ioy">
        {timedOut ? <Clock className="mx-auto text-forensic-muted" size={32} aria-hidden="true" data-id="element-1649" data-mp="2vkuvrvmasl4u" /> : <Loader2 className="mx-auto animate-spin text-forensic-crimson-soft" size={32} aria-hidden="true" data-id="element-1650" data-mp="30imw9e10dfkn" />}
        <h1 className="mt-5 text-xl font-semibold tracking-tight" data-id="element-1651" data-mp="3p5w2xkdohiej">
          {timedOut ? 'Pro isn’t active yet' : 'Activating Pro…'}
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-forensic-muted" data-id="element-1652" data-mp="3gay3dug0z7e8">
          {timedOut ? 'If you were charged, Pro will activate shortly. You can check again or continue to your dashboard.' : 'Confirming your subscription with our payment provider. This usually takes a few seconds.'}
        </p>
        {timedOut && <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center" data-id="element-1653" data-mp="7u3ddfkbthhk">
            <button type="button" onClick={onRetry} className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-xl bg-forensic-crimson px-6 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-forensic-crimson-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-forensic-crimson-soft" data-id="element-1654" data-mp="2v09hyg31hb6">
              <RefreshCw size={16} aria-hidden="true" data-id="element-1655" data-mp="2k5xwsbv2x7my" />
              Check again
            </button>
            <button type="button" onClick={() => navigate('/dashboard')} className="inline-flex min-h-[48px] items-center justify-center rounded-xl border border-forensic-line-strong px-6 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30" data-id="element-1656" data-mp="2p251k1bqod3b">
              Go to dashboard
            </button>
          </div>}
      </div>
    </div>;
}